import { accountsAction } from './accounts.slice';
import { updateProfileApi, updatePasswordApi } from 'utils/apis';
import { STATUS_CODE } from 'common/constants';
import { message } from 'antd';

export const updateProfile = (payload) => async (dispatch) => {
  try {
    dispatch(accountsAction.startLoading());
    const response = await updateProfileApi(payload);
    // console.log('response.status', response.status);
    if (response.status === STATUS_CODE.Ok) {
      dispatch(accountsAction.stopLoading());
      const data = response.data.data;
      message.success(data, 3);
      //   dispatch(categoryAction.setCategories(response.data.data));
    } else {
      dispatch(accountsAction.stopLoading());
      const data = response.data.data;
      message.error(data || 'Request was updated successful!', 3);
    }
  } catch (error) {
    message.error(`Error: ${error.response.data.message || 'Something went wrong'}`, 3);
    dispatch(accountsAction.StopLoading());
  }
};
export const updatePassword = (payload) => async (dispatch) => {
  try {
    dispatch(accountsAction.startLoading());

    // Use the API function to make the request
    const response = await updatePasswordApi(payload);

    if (response.status === STATUS_CODE.Ok) {
      const data = response.data.data;
      dispatch(accountsAction.stopLoading());
      if (response.data.error) {
        dispatch(accountsAction.setErrorMsg(data));
      } else {
        message.success(data, 3);
      }

      // dispatch other actions as needed, for example:
      // dispatch(categoryAction.setCategories(response.data.data));
    } else {
      dispatch(accountsAction.stopLoading());
      const data = response.data.data;
      message.error(data || 'Something went wrong', 3);
    }
  } catch (error) {
    dispatch(accountsAction.stopLoading());
    const errorMessage = error.response?.data?.message || 'Something went wrong';
    message.error(`Error: ${errorMessage}`, 3);
  }
};

export const emptyState = () => async (dispatch) => {
  dispatch(accountsAction.emptyState());
};
